import { initializeApp } from 'firebase/app';
import {
  CACHE_SIZE_UNLIMITED,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);

// Persistent multi-tab IndexedDB cache is configured at Firestore creation time.
// This is the current Firebase API and avoids the deprecated
// enableMultiTabIndexedDbPersistence() initialization path.
const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    cacheSizeBytes: CACHE_SIZE_UNLIMITED,
    tabManager: persistentMultipleTabManager(),
  }),
});

// Persistence is part of initializeFirestore above; keep the exported promise for
// callers that already await it without requiring a second persistence setup.
export const firestorePersistenceReady = Promise.resolve(true);

const auth = getAuth(app);
export const authPersistenceReady = setPersistence(auth, browserLocalPersistence)
  .then(() => true)
  .catch((error) => {
    console.warn('Firebase Auth local persistence unavailable:', error?.code || error);
    return false;
  });

const storage = getStorage(app);
const functions = getFunctions(app);

export { app, db, auth, storage, functions };
